import { tz as tzFn } from '@date-fns/tz';
import { add, isBefore, parse } from 'date-fns';

import { timezone } from './timezone';

export function openingAndClosing(
  { from, to }: { from: string; to: string },
  tz: string,
  now: Date = new Date()
): [Date, Date] {
  const timeZone = timezone(tz);
  const opening = parse(from, `HH:mm`, now, { in: tzFn(timeZone) });
  let closing = parse(to, `HH:mm`, now, { in: tzFn(timeZone) });

  if (isBefore(closing, opening)) {
    closing = add(closing, { days: 1 });
  }

  return [opening, closing];
}
